export default __webpack_public_path__ + "static/tap-to-phone-merchant-acquiring-solution-5300342670decb162494929f52ca4ab8.png";